module.exports = __webpack_public_path__ + "assets/img/dzh-12.f26ed7ff.jpg";